import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import "./SkillTemplate.scss";
import SkillTemplateFull from "../../components/skill/SkillTemplateFull";
import SkillTemplateUpdate from "../../components/skill/SkillTemplateUpdate";
import SkillTemplateDelete from "../../components/skill/SkillTemplateDelete";

const SkillTemplate = () => {
  const { idSkillTemplate } = useParams();
  const [skillTemplate, setSkillTemplate] = useState();
  const [isUpdate, setIsUpdate] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setIsUpdate(false);
    setIsDelete(false);
    setRefresh(false);
    setTimeout(() => {
      api
        .get(`/skilltemplate/${idSkillTemplate}/`)
        .then((response) => {
          setSkillTemplate(response.data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }, 500);
  }, [refresh]);

  return (
    <div className="skill-template">
      {isLoading && (
        <div className="loading-data">
          <div className="loading-spinner"></div>
          <div className="loading-text">Chargement...</div>
        </div>
      )}
      {!isLoading && skillTemplate == null && (
        <div className="no-data">
          <p>
            <strong>Compétence introuvable</strong>
          </p>
        </div>
      )}
      {!isLoading && skillTemplate && (
        <>
          {isUpdate && (
            <>
              <SkillTemplateUpdate
                skillTemplate={skillTemplate}
                setIsUpdate={setIsUpdate}
                setRefresh={setRefresh}
              />
            </>
          )}

          {isDelete && (
            <>
              <SkillTemplateDelete
                skillTemplate={skillTemplate}
                setIsDelete={setIsDelete}
              />
            </>
          )}

          {!isUpdate && !isDelete && (
            <>
              <SkillTemplateFull
                skillTemplate={skillTemplate}
                setIsUpdate={setIsUpdate}
                setIsDelete={setIsDelete}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SkillTemplate;
